import React, {useCallback, useEffect, useRef} from "react";
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Slider,
  Switch,
  TimePicker,
  TreeSelect,
  Upload,
} from "antd";
import {FontStyleTypes} from "../../../constants/WidgetConstants";
import _ from "lodash";
import styled from "styled-components";
import {
  AntdFormItemWrapper,
  getAntdCascaderPopupStyeld,
  getAntdDatePickerPopupStyled,
  getAntdSelectPopupStyled,
  getAntdTreeSelectPopupStyled
} from "widgets/widgetStyled";
import {ButtonWrapper} from "../../TableWidget/component";
import {connect} from "react-redux";
import {getIconPark} from "../../../components/propertyControls/IconSelectControl";
import {typeToCache, typeToForm, typeToValue} from "./typeToValue";
import DynamicFormsUpload from "./Upload";
import UploadImageWidget from "@byk/pages/components/UploadImageWidget";

const {TextArea} = Input;
const {RangePicker} = DatePicker;
const PLACEHOLDER = '请输入';

type LayoutType = Parameters<typeof Form>[0]['layout'];
const inputNumberType: any = ['inputNumber', 'integer', 'long'];
const textAreaType: any = ['textarea', 'textArea'];
export const dateType: any = ['date'];
const timePickerType: any = ['timePicker'];
const dateRangePickerType: any = ['dateRangePicker'];
const cascaderType: any = ['cascader'];
const uploadType: any = ['upload', 'image'];
const radioType: any = ['radio', 'bool'];
const selectType: any = ['select', 'dict', 'enum'];
const treeSelectType: any = ['treeSelect'];
const checkboxType: any = ['checkbox'];
const sliderType: any = ['slider'];
const switchType: any = ['switch', 'boolean'];

const FormContainerDiv = styled.div<any>`
  width: 100%;
  height: 100%;
  ${ props => props.dynamicHeight !== 'AUTO_HEIGHT' && `overflow-y: auto;`}
 .ant-picker-range .ant-picker-active-bar {
     background: ${(props) => props.accentColor} !important;
  }

 .ant-btn {
  margin-right: 8px !important;
  margin-bottom: 8px !important;
 }
 .ant-form-item{
   margin-bottom: 14px;
 }
  .ant-form-item-label label{
    color: ${({labelTextColor})=> labelTextColor };
    font-size: ${({labelTextSize})=> labelTextSize };
    font-weight: ${({labelStyle})=> labelStyle&&labelStyle.indexOf('BOLD')>=0?'bold':'normal' };
    font-style: ${({labelStyle})=> labelStyle&&labelStyle.indexOf('ITALIC')>=0?'italic':'normal' };
  }

 ${({isDisabled}) => {
  return isDisabled ? `
     .ant-form-item-label label {
        color: var(--wds-color-text-disabled) !important;
     }
   ` : '';
}}

  ${({isReadonly}) => {
  return isReadonly ? `
      .ant-form {
        background-color: rgb(248, 250, 252) !important;
      }
      .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        content: '' !important;
      }

      .ant-form-item-label label {
        color: var(--wds-color-text-disabled) !important;
      }

      .ant-input,
      .ant-input-number,
      .ant-picker,
      .ant-select-selector,
      .ant-btn,
      .ant-input-number-disabled:hover,
      .ant-input-disabled:hover,
      .ant-picker-disabled:hover,
      .ant-upload-disabled:hover,
      .ant-input-number-disabled .ant-input-number-input,
      .ant-input-disabled,
      .ant-picker-disabled input,
      .ant-picker-disabled,
      .ant-select-disabled .ant-select-selector {
        border: none !important;
        background-color: #FFFFFF !important;
        box-shadow: none !important;
      }
    ` : '';
}}
`

function DynamicFormsCmpV2(props: any) {
  const {
    currentData,
    onFinish: eventSubmit,
    labelPosition,
    colSpans,
    isDisabled,
    isReadonly,
    labelTextColor,
    labelTextSize,
    labelStyle,
    primaryBtnColor,
    backgroundColor,
    borderColor,
    borderRadius,
    borderWidth,
    boxShadow,
    buttons,
    onExecuteAction,
    appsmith,
    labelAlignment,
    labelWidth,
    updateWidgetMeta,
    value,
    dynamicHeight
  } = props;
  const [form] = Form.useForm();
  const appBoxShadow = appsmith.theme.boxShadow.appBoxShadow;
  const appBorderRadius = appsmith.theme.borderRadius.appBorderRadius;
  const cacheFormValues = useRef<Record<string, unknown>>({});
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const onFinish = (values: any) => {
    eventSubmit && eventSubmit(values);
  };
  const setCacheValues = (vs:any)=>{
    cacheFormValues.current = vs;
  }
  const cacheWidgetValues = useRef(null);
  const onChange = (v:any, allV:any)=>{
    let valueV: any = typeToValue(currentData, allV);
    cacheWidgetValues.current = valueV;
    updateWidgetMeta(valueV);
  }
  const onFinishFailed = () => {
  };
  const showTypeValue = (v:any, type?:any)=>{
    if(_.isBoolean(v)){
      return <Switch checked={v} disabled />;
    }else if(type === 'image'){
      return (
        <UploadImageWidget
          isReadonly={true}
          value={v}
          previewSize={30}
        />
      )
    }else{
      return v;
    }

  }

  const FormItems = useCallback(() => {
    const inputType: any = [].concat(
      inputNumberType,
      textAreaType,
      dateType,
      timePickerType,
      dateRangePickerType,
      selectType,
      cascaderType,
      checkboxType,
      radioType,
      sliderType,
      switchType,
      treeSelectType,
      uploadType
    );
    if(isReadonly){
      let formV = form.getFieldsValue();
      let cacheV = typeToCache(currentData, formV);
      setCacheValues(cacheV);
    }

    const GetItem = useCallback((itemProps: any) => {
      const {primaryBtnColor} = props
      const {children, data} = itemProps
      const label = data.name
      const name = data.id
      const rules = [{required: data.required, message: data.message}]
      const span = data.span || colSpans

      return (
        <Col span={span}>
          <AntdFormItemWrapper
            {...formItemLayout}
            label={label}
            name={name}
            rules={rules}
            accentColor={primaryBtnColor}
            appBoxShadow={appBoxShadow}
            appBorderRadius={appBorderRadius}
          >
            {isReadonly?(
              <>{showTypeValue(cacheFormValues.current[itemProps.data.id], data.type)}</>
            ): children}
          </AntdFormItemWrapper>
        </Col>
      )
    }, [currentData, isReadonly, labelWidth, labelAlignment])

    // 动态生成CSS样式
    const dynamicStyles = `
      .dynamicFormDatePickerWidget__popover {
        ${getAntdDatePickerPopupStyled(primaryBtnColor)}
      }

      .dynamicFormCascaderPopup {
        ${getAntdCascaderPopupStyeld(primaryBtnColor)}
      }

      .dynamicFormSelectPopup {
        ${getAntdSelectPopupStyled(primaryBtnColor)}
      }

      .dynamicFormTreeSelectPopup {
        ${getAntdTreeSelectPopupStyled(primaryBtnColor)}
      }
    `;

    return (currentData || []).map((i: any) => {
      let _isDisabled = i.disabled || isDisabled;
      return (
        <>
          <style>{dynamicStyles}</style>
          {
            uploadType.includes(i.type)
            &&
            <GetItem data={i}>
              {/*<Upload disabled={_isDisabled}><Button icon={<UploadOutlined/>}>上传</Button></Upload>*/}
              <DynamicFormsUpload disabled={_isDisabled} />
            </GetItem>
          }
          {
            treeSelectType.includes(i.type)
            &&
            <GetItem data={i}>
              <TreeSelect popupClassName={'dynamicFormTreeSelectPopup'} disabled={_isDisabled} style={{width: '100%'}}
                          placeholder={PLACEHOLDER} allowClear treeData={i.formValues}/>
            </GetItem>
          }
          {
            switchType.includes(i.type)
            &&
            <GetItem data={i}>
              <Switch disabled={_isDisabled}/>
            </GetItem>
          }
          {
            sliderType.includes(i.type)
            &&
            <GetItem data={i}>
              <Slider disabled={_isDisabled}/>
            </GetItem>
          }
          {
            radioType.includes(i.type)
            &&
            <GetItem data={i}>
              <Radio.Group disabled={_isDisabled} options={i.formValues}/>
            </GetItem>
          }
          {
            checkboxType.includes(i.type)
            &&
            <GetItem data={i}>
              <Checkbox.Group disabled={_isDisabled} options={(i.formValues||[]).map((i:any)=>{
                return {
                  ...i,
                  value: i.value?.toString()
                }
              })}/>
            </GetItem>
          }
          {
            cascaderType.includes(i.type)
            &&
            <GetItem data={i}>
              <Cascader fieldNames={{label: 'name', value: 'id', children: 'children'}} popupClassName={'dynamicFormCascaderPopup'} disabled={_isDisabled} options={i.formValues}
                        placeholder={PLACEHOLDER} style={{width: '100%'}}/>
            </GetItem>
          }
          {
            selectType.includes(i.type)
            &&
            <GetItem data={i}>
              <Select fieldNames={{label: i.type==='select'?'label':'name', value: i.type==='select'?'value':'id'}} popupClassName={'dynamicFormSelectPopup'} disabled={_isDisabled} placeholder={PLACEHOLDER}
                      options={i.formValues} style={{width: '100%'}}/>
            </GetItem>
          }
          {
            dateRangePickerType.includes(i.type)
            &&
            <GetItem data={i}>
              <RangePicker popupClassName={'dynamicFormDatePickerWidget__popover'} disabled={_isDisabled}
                           style={{width: '100%'}}/>
            </GetItem>
          }
          {
            timePickerType.includes(i.type)
            &&
            <GetItem data={i}>
              <TimePicker popupClassName={'dynamicFormDatePickerWidget__popover'} disabled={_isDisabled}/>
            </GetItem>
          }
          {
            dateType.includes(i.type)
            &&
            <GetItem data={i}>
              <DatePicker popupClassName={'dynamicFormDatePickerWidget__popover'} disabled={_isDisabled}
                          placeholder={PLACEHOLDER} style={{width: '100%'}}/>
            </GetItem>
          }
          {
            textAreaType.includes(i.type)
            &&
            <GetItem data={i}>
              <TextArea disabled={_isDisabled} rows={4}/>
            </GetItem>
          }
          {
            inputNumberType.includes(i.type)
            &&
            <GetItem data={i}>
              <InputNumber disabled={_isDisabled} style={{width: '100%'}}/>
            </GetItem>
          }
          {
            !inputType.includes(i.type)
            &&
            <GetItem data={i}>
              <Input disabled={_isDisabled} placeholder={PLACEHOLDER}/>
            </GetItem>
          }
        </>
      )
    })
  }, [currentData, isReadonly, labelWidth, labelAlignment, colSpans]);

  let formLayout: LayoutType = labelPosition === 'Left' ? 'horizontal' : 'vertical';
  let fontStyle = labelStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : "normal";
  let fontWeight = labelStyle?.includes(FontStyleTypes.BOLD) ? "bold" : "normal";
  const formItemLayout =
    formLayout === 'horizontal'
      ? {
        labelCol: {
          style: {
            color: labelTextColor,
            fontSize: labelTextSize,
            fontStyle,
            fontWeight,
            width: `${labelWidth}px`
          }
        },
        labelAlign: labelAlignment
      }
      : null;
  const reFormValid = ()=>{
    let isSubmit = false;
    _.each(currentData, (item:any)=>{
      if(item.required&&(value[item.id]===undefined||value[item.id]===null)){
        isSubmit = true;
      }
    });
    setSubmitDisabled(isSubmit);
  }
  //初始化表单值
  useEffect(() => {
    if(currentData&&
      currentData[0]&&
      currentData[0]['value']===undefined&&
      !_.isEmpty(value)&&
      !_.isEqual(value, cacheWidgetValues.current)
    ){
      updateWidgetMeta({});
    }
    let currentValue:any = { ...value };
    if(currentData&&currentData[0]&&currentData[0]['value']!==undefined){
      _.each(currentData, (i:any)=>{
        currentValue[i.id] = i.value;
      })
    }
    if(!_.isEmpty(currentValue)){
      let formV: any = typeToForm(currentData, currentValue);
      form.setFieldsValue(formV);
      reFormValid();
    }

  }, [currentData, value]);
  const buttonOnClick = (item:any)=>{
    if(item.id==='reset'){
      form.resetFields();
    }
    item.onClick && onExecuteAction(item, form.getFieldsValue(), 'onClick');
  };

  const reBtnIsDisabled = (item:any)=>{
    if(item.isDisabled){
      return true;
    }else if(item.disabledWhenInvalid){
      return submitDisabled;
    }else{
      return false;
    }
  }
  return (
    <FormContainerDiv accentColor={primaryBtnColor} isDisabled={isDisabled} dynamicHeight={dynamicHeight}
                      labelStyle={labelStyle} labelTextSize={labelTextSize} labelTextColor={labelTextColor}>
      <Form
        className='Widget_dynamicForm_'
        form={form}
        layout={formLayout}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onChange}
        disabled={isDisabled}
        autoComplete="off"
        style={{
          background: backgroundColor || '#fff',
          borderColor: borderColor || 'none',
          borderRadius: borderRadius,
          borderWidth: borderWidth,
          boxShadow: boxShadow,
          padding: '10px',
        }}
      >
        <Row gutter={10}>
          {_.isEmpty(currentData)?null:<FormItems/>}
        </Row>
        {
          !isReadonly&&
          !_.isEmpty(buttons)&&
          <Form.Item style={{textAlign: 'center'}}>
            {_.sortBy(Object.values(buttons), ['index']).map((item: any) => {
              let btnProps: any = {
                borderRadiusBtn: item.borderRadius,
                boxShadowBtn: item.boxShadow,
                backgroundBtn: item.buttonColor || appsmith.theme.colors.primaryColor,
                btnTextAlign: item.btnTextAlign,
                btnFontSize: item.fontSize,
                btnFontStyle: item.fontStyle,
                btnFontColor: item.textColor  || appsmith.theme.colors.primaryColor,
              };

              if (item.buttonVariant == 'primary' && !item.textColor ) {
                btnProps.btnFontColor = '#FFFFFF';
              }

              Object.keys(btnProps).forEach(key => {
                let val = (btnProps[key] || '').trim();
                if (val.startsWith("{{") && val.endsWith("}}")) {
                  btnProps[key] = eval(val);
                }
              })

              let iconRight = item.iconAlign == 'right' && item.iconName;
              let iconLeft = item.iconAlign != 'right' && item.iconName;
              btnProps = {...btnProps, iconRight, iconLeft}

              return <ButtonWrapper {...btnProps}>
                <Button
                  disabled={reBtnIsDisabled(item)}
                  type={(item.buttonVariant || 'secondary')}
                  onClick={() => {
                    buttonOnClick(item);
                  }}
                  onMouseEnter={() => item.onMouseEnter && onExecuteAction(item, form.getFieldsValue(), 'onMouseEnter')}>
                  {iconLeft && getIconPark(item.iconName)}
                  {item.label}
                  {iconRight && getIconPark(item.iconName)}
                </Button>
              </ButtonWrapper>
            })}

          </Form.Item>
        }

      </Form>
    </FormContainerDiv>
  )
}
const stateToProp = (state:any)=>{
  return {
    appsmith: state.evaluations.tree.appsmith
  }
}

export default connect(stateToProp)(DynamicFormsCmpV2);
